<template>
  <v-dialog :value="value" @input="$emit('input', $event)" max-width="600px">
    <v-card>
      <v-card-title>
        <span class="text-h5">設定帳密</span>
        <v-spacer></v-spacer>
        <v-btn icon @click="$emit('input', false)">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>

      <v-card-text>
        <v-form ref="form" v-model="formValid">
          <!-- 名稱 -->
          <v-text-field
            v-model="form.name"
            :rules="[rules.required]"
            required
            outlined
            dense
          >
            <template v-slot:label>
              名稱 <span class="red--text">*</span>
            </template>
          </v-text-field>

          <!-- 帳號 -->
          <v-text-field
            v-model.trim="form.account"
            hint="帳號前後空白會自動移除；建議使用手機號碼，且不可與其他帳號重複"
            persistent-hint
            :rules="[rules.accountRequired]"
            required
            outlined
            dense
          >
            <template v-slot:label>
              帳號 <span class="red--text">*</span>
            </template>
          </v-text-field>

          <!-- 登入密碼 -->
          <v-text-field
            v-model="form.password"
            :rules="[rules.required]"
            :type="showPassword ? 'text' : 'password'"
            :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
            @click:append="showPassword = !showPassword"
            autocomplete="new-password"
            required
            outlined
            dense
          >
            <template v-slot:label>
              登入密碼 <span class="red--text">*</span>
            </template>
          </v-text-field>

          <!-- Email -->
          <v-text-field
            v-model="form.email"
            :rules="[rules.required, rules.email]"
            autocomplete="off"
            required
            outlined
            dense
          >
            <template v-slot:label>
              Email <span class="red--text">*</span>
            </template>
          </v-text-field>
        </v-form>
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text @click="$emit('input', false)">
          取消
        </v-btn>
        <v-btn
          color="teal"
          :dark="formValid"
          :disabled="!formValid"
          @click="handleSubmit"
        >
          送出
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
/**
 * AccountCredentialsDialog - 設定帳密 Dialog
 *
 * Props:
 * - value: Dialog 開關狀態（v-model）
 * - account: 要編輯的帳號物件
 *
 * Events:
 * - input: Dialog 開關變更
 * - submit: 提交表單
 */
export default {
  name: 'AccountCredentialsDialog',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    account: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      formValid: false,
      showPassword: false,  // 控制密碼顯示/隱藏
      form: {
        id: null,
        name: '',
        account: '',
        password: '',
        email: ''
      },
      rules: {
        required: v => !!v || '此欄位為必填',
        accountRequired: v => (typeof v === 'string' ? !!v.trim() : !!v) || '此欄位為必填',
        email: v => /.+@.+\..+/.test(v) || '請輸入正確的 Email 格式'
      }
    }
  },
  watch: {
    // 當 Dialog 打開時，載入帳號資料
    value(newVal) {
      if (newVal && this.account) {
        this.form = {
          id: this.account.id,
          name: this.account.name,
          account: this.account.account,
          password: this.account.password, // 密碼留空（選填）
          email: this.account.email
        }

        // 重置驗證
        if (this.$refs.form) {
          this.$refs.form.resetValidation()
        }
      }
    }
  },
  methods: {
    handleSubmit() {
      this.form.account = this.form.account.trim()

      if (!this.$refs.form.validate()) {
        return
      }

      this.$emit('submit', {
        id: this.form.id,
        name: this.form.name,
        account: this.form.account,
        password: this.form.password,
        email: this.form.email
      })
    }
  }
}
</script>
